import React, { useState } from 'react';
import { Button } from '@lifepal/lifepal-design-system';
import redirectWhatsapp from '../../lib/submitHandler/redirectWhatsapp';
import styles from './Footer.module.scss';

export const Footer = () => {
  const [emailInput, setEmailInput] = useState('');

  const year = new Date().getFullYear();

  const validateEmail = (email: string) => {
    const re = /^[^@]+@[^.]+\..+$/;

    return re.test(email);
  };

  const openGmap = () => {
    window.location.href = "http://maps.google.com/?ll=-6.2948157714414865, 106.81538242044597";
  }

  return (
    <footer>
      <div className="footer__form--group">
        <div className="mb-2 footer__form--title">
          <p className="heading-sm-m">
            Dapatkan Tips dan Informasi Terpercaya untuk Keuangan dan
            Asuransimu
          </p>
        </div>
        <div className="mb-2 footer__form">
          <form id="newsletter" action="/media/newsletter/" noValidate>
            <input type="hidden" name="utm_source" value="core" />
            <input
              type="hidden"
              name="utm_campaign"
              value="CORE_Newsletter"
            />
            <input
              type="hidden"
              name="utm_medium"
              value="footer_subscription"
            />
            <div className="footer__form--item">
              <input
                onChange={(e) =>
                  setEmailInput(e.target.value)
                }
                name="email"
                type="email"
                placeholder="email@anda.com"
                className="required email"
                disabled={false}
                maxLength={40}
              />
              <Button
                className="btn-subscribe"
                type="submit"
                variant="primary"
                onClick={()=>{}}
                disabled={!validateEmail(emailInput)}
              >
                Langganan
              </Button>
            </div>
          </form>
        </div>
      </div>

      <div className="footer__item footer__insurance">
        <div className="footer__insurance--item">
          <div className="company__name">Asuransi Kesehatan</div>
          <ul>
            <li>
              <a
                className="text-muted"
                href="/asuransi/kesehatan/"
                title="Asuransi Kesehatan"
              >
                Asuransi Kesehatan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/kesehatan-keluarga/"
                title="Asuransi Keluarga"
              >
                Asuransi Keluarga
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/kesehatan-cashless/"
                title="Asuransi Cashless"
              >
                Asuransi Cashless
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/melahirkan/"
                title="Asuransi Melahirkan"
              >
                Asuransi Melahirkan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/gigi/"
                title="Asuransi Gigi"
              >
                Asuransi Gigi
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/rawat-jalan/"
                title="Asuransi Rawat Jalan"
              >
                Asuransi Rawat Jalan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/penyakit-kritis/"
                title="Asuransi Penyakit Kritis"
              >
                Asuransi Penyakit Kritis
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/covid-19/"
                title="Asuransi Covid-19"
              >
                Asuransi Covid-19
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/hospital-cash-plan/"
                title="Asuransi Cash Plan"
              >
                Asuransi Cash Plan
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__insurance--item">
          <div className="company__name">Asuransi Jiwa</div>
          <ul>
            <li>
              <a
                className="text-muted"
                href="/asuransi/jiwa/"
                title="Asuransi Jiwa"
              >
                Asuransi Jiwa
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/kredit/"
                title="Asuransi Kecelakaan"
              >
                Asuransi Kecelakaan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/dwiguna/"
                title="Asuransi Dwiguna"
              >
                Asuransi Dwiguna
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/pendidikan/"
                title="Asuransi Pendidikan"
              >
                Asuransi Pendidikan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/unit-link/"
                title="Asuransi Unit Link"
              >
                Asuransi Unit Link
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/jiwa-rop/"
                title="Jiwa Pengembalian Premi"
              >
                Jiwa Pengembalian Premi
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/kredit/"
                title="Asuransi Kredit"
              >
                Asuransi Kredit
              </a>
            </li>
            <li>
              <a className="text-muted" href="/asuransi/dplk/" title="DPLK">
                DPLK
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__insurance--item">
          <div className="company__name">Asuransi Kendaraan</div>
          <ul>
            <li>
              <a
                className="text-muted"
                href="/asuransi/mobil/"
                title="Asuransi Mobil"
              >
                Asuransi Mobil
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/all-risk/"
                title="Asuransi All Risk"
              >
                Asuransi All Risk
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/tlo/"
                title="Asuransi TLO"
              >
                Asuransi TLO
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/motor/"
                title="Asuransi Motor"
              >
                Asuransi Motor
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__insurance--item">
          <div className="company__name">Asuransi Syariah</div>
          <ul>
            <li>
              <a
                className="text-muted"
                href="/asuransi/syariah/"
                title="Asuransi Syariah"
              >
                Asuransi Syariah
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/kesehatan-syariah/"
                title="Asuransi Kesehatan Syariah"
              >
                Asuransi Kesehatan Syariah
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/jiwa-syariah/"
                title="Asuransi Jiwa Syariah"
              >
                Asuransi Jiwa Syariah
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/mobil-syariah/"
                title="Asuransi Mobil Syariah"
              >
                Asuransi Mobil Syariah
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__insurance--item">
          <div className="company__name">Asuransi Perusahaan</div>
          <ul>
            <li>
              <a
                className="text-muted"
                href="/asuransi/karyawan/"
                title="Asuransi Karyawan"
              >
                Asuransi Karyawan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/proyek/"
                title="Asuransi Proyek"
              >
                Asuransi Proyek
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/properti/"
                title="Asuransi Properti"
              >
                Asuransi Properti
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/cargo/"
                title="Asuransi Cargo"
              >
                Asuransi Cargo
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__insurance--item">
          <div className="company__name">Asuransi Lainnya</div>
          <ul>
            <li>
              <a className="text-muted" href="/" title="Asuransi">
                Asuransi
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/perjalanan/"
                title="Asuransi Perjalanan"
              >
                Asuransi Perjalanan
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/rumah/"
                title="Asuransi Rumah"
              >
                Asuransi Rumah
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/pengiriman/"
                title="Asuransi Pengiriman"
              >
                Asuransi Pengiriman
              </a>
            </li>
            <li>
              <a
                className="text-muted"
                href="/asuransi/pertanian/"
                title="Asuransi Pertanian"
              >
                Asuransi Pertanian
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div className={styles.footer__item_group}>
          <div className="footer__item grid__one">
            <div className="company__name">
              PT Anugrah Atma Adiguna
            </div>
            <div className="company__info">
              <p className="company__address">
                CIBIS 9 17th Floor jl TB Simatupang No.2
                Cilandak Timur, Pasar Minggu Jakarta
                Selatan 12560
              </p>
            </div>
            <div>
              <Button
                className={styles.btn_map}
                type="button"
                variant="ghost"
                onClick={() => openGmap()}
              >
                <div className={`iconSprites iconSprites-simple-location`}>
                </div>
                <span>Google Maps</span>
              </Button>
            </div>
          </div>

          <div className="footer__item grid__one">
            <div className="company__name">
              Layanan Customer Support
            </div>
            <div className="company__info">
              <p className="company__address">
                <div>WA (Chat only)</div>
                <div className={styles.company__address_link} onClick={() => redirectWhatsapp()}>0823 300 300 27</div>
              </p>
              <p className="company__address">
                <div>Email</div>
                <a className={styles.company__address_link} href="mailto:support@lifepal.co.id">support@lifepal.co.id</a>
              </p>
              <p className="company__address">
                <div>Phone</div>
                <a className={styles.company__address_link} href="tel:622131116121">021 3111 6121</a>
              </p>
            </div>
          </div>

          <div className="footer__item grid__two">
            <div className="company__name">Lifepal</div>

            <ul>
              <li>
                <a
                  className="text-muted"
                  href="/media/tentang/"
                  rel="noopener noreferrer"
                  title="Tentang Kami"
                >
                  Tentang Kami
                </a>
              </li>
              <li>
                <a
                  className="text-muted"
                  href="/ketentuan/"
                  rel="noopener noreferrer"
                  title="Ketentuan"
                >
                  Ketentuan
                </a>
              </li>
              <li>
                <a
                  className="text-muted"
                  href="/asuransi/"
                  rel="noopener noreferrer"
                  title="Asuransi"
                >
                  Asuransi
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__item grid__three">
            <div className="company__name">Social Media</div>

            <ul>
              <li>
                <a
                  className="text-muted"
                  target="_blank"
                  href="https://www.facebook.com/lifepal"
                  rel="noopener noreferrer me nofollow"
                  title="Facebook Lifepal"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  className="text-muted"
                  href="https://www.instagram.com/lifepal"
                  target="_blank"
                  rel="noopener noreferrer me nofollow"
                  title="Instagram Lifepal"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/lifepal"
                  target="_blank"
                  rel="noopener noreferrer me nofollow"
                  className="text-muted"
                  title="Twitter Lifepal"
                >
                  Twitter
                </a>
              </li>
              <li>
                <a
                  className="text-muted"
                  href="https://www.youtube.com/channel/UC-14O1IUXJ_m5t8PRAfWm5w"
                  rel="noopener noreferrer me nofollow"
                  title="Youtube Lifepal"
                >
                  Youtube
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__item grid__four">
            <div className="footer__image--group">
              <div className="company__name">
                Metode Pembayaran & Program Cicilan 0%
              </div>
              <img
                alt="Metode Pembayaran"
                loading="lazy"
                src="/media/static/images/payment-method-and-installment.png"
                width="300px"
                height="143px"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.footer__info}>
        <p className={styles.copy__rights}>
          Copyright © {year} Lifepal-- Dikelola oleh PT Anugrah Atma Adiguna, 
          pialang asuransi berizin dan diawasi oleh OJK sesuai KEP-018/KMK.17/1992 
          dan anggota APPARINDO 060-2001/APPARINDO/{year}. Lifepal berusaha untuk 
          menyajikan informasi yang akurat dan terbaru namun dapat berbeda dari 
          informasi yang diberikan oleh penyedia layanan / institusi keuangan. 
          Keseluruhan informasi diberikan tanpa jaminan, kami menyarankan untuk 
          melakukan verifikasi sebelum melakukan keputusan finansial Anda.
        </p>
      </div>
    </footer>
  );
};